module.exports = __webpack_public_path__ + "media/application/images/ui/user-badge-aeebfa9aeb9bd84946657f68b3c49aac.png";